import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BusinessIcon from '@mui/icons-material/Business';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ExtensionIcon from '@mui/icons-material/Extension';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import ImportExportIcon from '@mui/icons-material/ImportExport';

import './index.css';
import Billing from './billing';
import AgencyTab from './account/agency';
import ImportHistory from './crm/import';
import Integrations from '../../components/Integration';
import ProfileTab from './account/profile';
import WorkspaceTab from './account/workspace';
import ApiKeysTab from '../../components/Integration/apiKeys';
import PropertyManagement from './crm/properties';
import TitleRoute from '../../components/titleRoute.js';

const tabs = [
  { label: 'Profile', id: 'profile', icon: <PersonOutlineIcon />, group: 'Account' },
  { label: 'Workspace', id: 'workspace', icon: <BusinessIcon />, group: 'Account' },
  { label: 'Billing', id: 'billing', icon: <CreditCardIcon />, group: 'Account' },
  { label: 'Integrations', id: 'integrations', icon: <ExtensionIcon />, group: 'Developer' },
  { label: 'CRM Properties', id: 'crm-properties', icon: <TableChartOutlinedIcon />, group: 'Data' },
  { label: 'Imports & Exports', id: 'import-export', icon: <ImportExportIcon />, group: 'Data' },
];

const sidebarGroups = ['Account', 'Developer', 'Data'];

const Settings = () => {
  const history = useHistory();
  const location = useLocation();
  const [tabId, setTabId] = useState('profile');

  useEffect(() => {
    const params = new URLSearchParams(location['search']);
    const tabParam = params.get('tab');
    if (tabParam && tabs.some(tab => tab['id'] === tabParam)) setTabId(tabParam);
  }, [location['search']])

  const handleTabClick = (id) => {
    setTabId(id);
    history.push(`?tab=${id}`);
  }

  return (
    <div className='content'>
      <div className='main-container setting-container'>
        <div className='page-title-area setting-page'>
          <TitleRoute />
        </div>
        <div className='bottom-content-area setting-bottom-content'>
          <div className='content account-tabs'>
            <div className='account-tab-inner'>
              <div className='left-area'>
                <nav className='settings-sidebar'>
                  <div className='settings-sidebar__header'>
                    <h3>Settings</h3>
                  </div>
                  {sidebarGroups.map(group => (
                    <div key={group} className='settings-sidebar__group'>
                      <span className='settings-sidebar__group-label'>{group}</span>
                      {tabs.filter(t => t.group === group).map(tab => (
                        <button
                          key={tab.id}
                          className={`settings-sidebar__item ${tabId === tab.id ? 'settings-sidebar__item--active' : ''}`}
                          onClick={() => handleTabClick(tab.id)}
                        >
                          <span className='settings-sidebar__icon'>{tab.icon}</span>
                          <span className='settings-sidebar__label'>{tab.label}</span>
                        </button>
                      ))}
                    </div>
                  ))}
                </nav>
              </div>
              <div className='right-tabs-area billing-tabs'>
                <div className='tabs-content'>
                  <TabPanel value={tabId} index='profile'> <ProfileTab /> </TabPanel>
                  <TabPanel value={tabId} index='workspace'> <WorkspaceTab /> </TabPanel>
                  <TabPanel value={tabId} index='billing'> <Billing /></TabPanel>
                  <TabPanel value={tabId} index='integrations'> <Integrations /></TabPanel>
                  <TabPanel value={tabId} index='crm-properties'> <PropertyManagement /></TabPanel>
                  <TabPanel value={tabId} index='import-export'> <ImportHistory /></TabPanel>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <div className='settings-tab-content'>{children}</div>}
    </div>
  )
}

export default Settings;